import { render, staticRenderFns } from "./cms-block-text.vue?vue&type=template&id=40740069&scoped=true"
import script from "./cms-block-text.vue?vue&type=script&lang=js"
export * from "./cms-block-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40740069",
  null
  
)

export default component.exports